import { showSharePanel } from './share.mjs';
import { dailyDate, utcDate, untilReset, pinDailySession } from './daily.mjs';
/** Install once, outside each game's rendering root. No runtime CDN dependency. */
export function mountBrand({ daily = true } = {}) {
  if (daily) pinDailySession();
  const mount = () => {
    if (document.querySelector('.jb-bar')) return;
    document.documentElement.classList.add('joybox-brand');
    const bar = document.createElement('nav');
    bar.className = 'jb-bar'; bar.setAttribute('aria-label', 'JoyBoxLabs');
    bar.innerHTML = '<a class="jb-logo" href="https://joyboxlabs.com/"><span aria-hidden="true">J</span>JoyBoxLabs</a><span class="jb-clock"></span><button class="jb-invite" type="button" aria-label="Share JoyBoxLabs">Share ↗</button><a class="jb-all" href="https://joyboxlabs.com/">All games ↗</a>';
    bar.querySelector('.jb-invite').onclick = () => showSharePanel('JoyBoxLabs · A little play. Every day.\nDaily puzzles, geography adventures and party games.\nCome play with me →\nhttps://joyboxlabs.com/');
    document.body.prepend(bar);
    const clock = bar.querySelector('.jb-clock');
    const update = () => {
      if (!daily) { clock.textContent = 'A little play. Every day.'; return; }
      if (utcDate() !== utcDate(dailyDate())) {
        if (!clock.querySelector('a')) {
          const link = document.createElement('a');
          link.textContent = 'New daily ready →';
          const url = new URL(location.href); url.search = ''; url.hash = '';
          // Geography keeps the selected game; no archive date carries into today.
          const game = new URL(location.href).searchParams.get('game');
          if (game) url.searchParams.set('game', game);
          link.href = url.href; clock.replaceChildren(link);
          clock.setAttribute('role', 'status');
        }
      } else {
        const seconds = Math.ceil(untilReset() / 1000);
        clock.textContent = `Next daily ${String(Math.floor(seconds / 3600)).padStart(2, '0')}:${String(Math.floor(seconds % 3600 / 60)).padStart(2, '0')} · UTC`;
      }
    };
    update();
    if (daily) { setInterval(update, 30000); document.addEventListener('visibilitychange', update); window.addEventListener('focus', update); }
    const params = new URL(location.href).searchParams;
    const arcadeDay = Number(params.get('day'));
    const sharedDate = params.get('edition') || (params.has('day') && Number.isInteger(arcadeDay) && arcadeDay > 0 && arcadeDay < 1000000 ? utcDate(arcadeDay * 86400000) : null);
    if (sharedDate && sharedDate !== utcDate()) {
      const notice = document.createElement('p'); notice.className = 'jb-edition-note';
      notice.textContent = 'Your friend shared an earlier daily result. You’re playing today’s challenge.';
      bar.after(notice);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true }); else mount();
}
